import { render } from "./OrderFormGuest.vue?vue&type=template&id=0683c60e"
import script from "./OrderFormGuest.vue?vue&type=script&lang=js"
export * from "./OrderFormGuest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__